import { simplePath } from "../../utils.js";
const GET_ORG_SETTINGS = 'v2/organization/:organization/profile-settings';
function get_org_settings_path(params) {
    return simplePath(GET_ORG_SETTINGS, params);
}
export { GET_ORG_SETTINGS, get_org_settings_path };
